import { Flex, Form, Select, Space, Typography } from 'antd';

import { SearchButtons } from '@app/components';
import { PREFIX } from '@app/constants';
import {
  MONTHS,
  YEARS,
  CURRENT_MONTH,
  CURRENT_YEAR,
} from '@app/pages/Analytics/data';
import { useDetailsOfExpensesReport } from '@app/pages/Analytics/DetailsOfExpensesReport/hooks';
import { DetailsOfExpensesReportTable } from '@app/pages/Analytics/DetailsOfExpensesReport/ui/DetailsOfExpensesReportTable';
import { useReportEffects } from '@app/pages/Analytics/hooks';
import '@pages/Analytics/DetailsOfExpensesReport/styles/DetailsOfExpensesReport.desktop.scss';

const { Text } = Typography;
const { Item } = Form;

export const DetailsOfExpensesReport = () => {
  const {
    handleReset,
    form,
    handleSubmitForm,
    tableData,
    handleSearchData,
    isLoading,
  } = useDetailsOfExpensesReport();
  useReportEffects({
    handleSearchData,
  });
  return (
    <div className={`${PREFIX}details-of-expenses-report`}>
      <Form
        form={form}
        onFinish={handleSubmitForm}
        initialValues={{
          filterMonth: CURRENT_MONTH.value,
          filterYear: CURRENT_YEAR,
        }}
      >
        <Space
          className="content-header-space"
          direction="vertical"
          size="large"
        >
          <Flex justify="space-between">
            <Space size="large" align="baseline">
              <Text strong>Период:</Text>
              <Item name="filterMonth">
                <Select
                  placeholder="Выбор месяца"
                  popupMatchSelectWidth={false}
                  options={MONTHS}
                  className="filters-select"
                />
              </Item>
              <Item name="filterYear">
                <Select
                  placeholder="Выбор года"
                  popupMatchSelectWidth={false}
                  options={YEARS}
                  className="filters-select"
                />
              </Item>
            </Space>
            <SearchButtons
              className="desktop-buttons"
              resetAll={handleReset}
              showData={form.submit}
            />
          </Flex>

          <DetailsOfExpensesReportTable
            isLoading={isLoading}
            tableData={tableData}
          />
        </Space>
      </Form>
    </div>
  );
};
